import styled from 'styled-components'
import { Pagination, Image, Button, Empty, Form, Typography } from 'antd'
import { IconFont, DeleteModal, SvgIcon, FilterForm, AiMailModal } from '@/components'
import {
  useGetEmail,
  useDelEmail,
  useGetEmailAttck,
  useGetPhishingPages,
  useGetAttachments,
  useCheckAvailableStatus,
} from './utils'
import { useGetAiEmailTemplate, useCreateAiEmailTemplate } from '../create/utils'
import { useDebounceFn } from 'ahooks'
import { useState } from 'react'
import { GetEmail } from '@/api/template'
import { SearchInput } from '@/components/search-input'
import { EditTemplate } from './edit-template'
import { GetPhishingParamsCreateTemplate } from './create-template'
import { Particulars } from './particulars'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { AdvancedPopover, DTOption } from '@/components/advanced-search'
import { t } from '@/i18n'
const { useForm } = Form
export const EmailTemplate = (props: any) => {
  const [getEmailParams, setGetEmailParams] = useState<GetEmail>({
    limit: 20,
    page: 1,
    // name: '',
    // origin_type: 0,
    // email_type: 0,
  })
  const [createForm] = useForm()
  const [delEmail, delLoading] = useDelEmail()
  const [availableStatus] = useCheckAvailableStatus()
  const [particulars, setParticulars] = useState({ visible: false, id: null })
  const { run } = useDebounceFn(
    value => {
      setGetEmailParams(origin => ({ ...origin, page: 1, name: value }))
    },
    {
      wait: 500,
    },
  )
  const closeParticulars = (data: any) => {
    setParticulars({ visible: false, id: null })
  }
  const [deleteModal, setDeleteModal] = useState({ visible: false, id: null })
  const [visible, setVisible] = useState({ visible: false, id: null, type: null, origin_type: '' })
  const [aiVisible, setAiVisible] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [getEmail, emailList] = useGetEmail({ GetEmailParams: getEmailParams })
  const [emailTemplateList, setEmailTemplateList] = useState([])
  const [getAiEmailTemplate, searchLoading] = useGetAiEmailTemplate()
  const [createAiEmailTemplate, submitLoading] = useCreateAiEmailTemplate()
  const [getPhishingParams, setGetPhishingParams] = useState<GetEmail>({
    limit: 9999999,
    page: 1,
    name: '',
  })
  const [getPhishingPages, getPhishing] = useGetPhishingPages({
    GetPhishingParams: getPhishingParams,
  })
  const [getAttachments, getAttachmentsList] = useGetAttachments({
    GetAttachmentsParams: getPhishingParams,
  })
  const [attckList] = useGetEmailAttck()
  const close = (data: any) => {
    if (data) {
      getEmail()
    }
    setVisible({ visible: false, id: null, type: null, origin_type: '' })
  }
  const handleCancel = (data: any) => {
    if (data) {
      getEmail()
    }
    setIsModalVisible(false)
  }
  const deleteEmailHandler = async () => {
    try {
      await delEmail({ id: deleteModal.id })
      if (
        getEmailParams.page > 1 &&
        (getEmailParams.page - 1) * getEmailParams.limit + 1 === emailList.total
      ) {
        setGetEmailParams(origin => ({ ...origin, page: getEmailParams.page - 1 }))
      } else {
        await getEmail()
      }

      setDeleteModal({ visible: false, id: null })
    } catch (err) {}
  }
  let option = {
    name: {
      type: 'input',
      label: '模板名称/邮件主题',
    },
    origin_type: {
      type: 'radio',
      label: '模板类型',
      data: [
        { name: '系统内置', id: 1 },
        { name: '自定义', id: 2 },
        { name: 'AI生成', id: 3 },
      ],
    },
    email_type: {
      type: 'radio',
      label: '邮件类型',
      data: [
        { name: '恶意附件', id: 2 },
        { name: '钓鱼链接', id: 1 },
      ],
    },
    attck_name: {
      type: 'multiple',
      label: 'ATT&CK',
      data: attckList?.map(item => ({ name: item.name, id: item.name })),
      typeof: 'array',
    },
  }
  const [visibleSearch, setVisibleSearch] = useState(false)
  const onFinish = values => {
    const { template, email, attck_name } = values
    setGetEmailParams(origin => ({
      ...origin,
      origin_type: template,
      page: 1,
      email_type: email,
      attck_name,
    }))
    setVisibleSearch(false)
  }
  const [visibles, setVisibles] = useState({ visible: false, cover: '' })
  return (
    <Template>
      <div className="title-btn">
        <Button
          type="primary"
          className="ai-btn"
          style={{
            marginLeft: 16,
            height: '32px',
            background: 'linear-gradient( 180deg, #2090A8 0%, #4F4FAE 100%)',
            border: 'none',
            opacity: availableStatus?.status === 'AvailableStatusTrue' ? 1 : 0.5,
            cursor: availableStatus?.status === 'AvailableStatusTrue' ? 'pointer' : 'not-allowed',
          }}
          onClick={() => {
            if (availableStatus?.status !== 'AvailableStatusTrue') return
            setAiVisible(true)
            setEmailTemplateList([])
          }}
        >
          <SvgIcon name="AI" width={'16px'} height={'16px'} style={{ marginRight: '8px' }} />
          {t('AI生成模板')}
        </Button>
        <Button type="primary" onClick={() => setIsModalVisible(true)}>
          {t('添加自定义模板')}
        </Button>
      </div>
      <FilterForm
        option={option}
        setSearchParams={setGetEmailParams}
        onReset={() => {
          setGetEmailParams({
            page: 1,
            limit: 10,
          })
        }}
      />

      {/* <AdvancedPopover
         onConfirm={onFinish}
         option={option}
         buttonLeft={
           <SearchInput
             inputProps={{
               placeholder: '模板名称、邮件主题',
               onChange: e => run(e.target.value),
             }}
           />
         }
         left={
           <Button type="primary" onClick={() => setIsModalVisible(true)}>
             添加自定义模板
           </Button>
         }
        /> */}
      <AiMailModal
        visible={aiVisible}
        modalType={'3'}
        placeholder={'请输入邮件主题描述，如：五一假期礼品领取'}
        onConfirm={(values, handleSuccess) => {
          console.log('onConfirm', values)
          const { name, subject, sender, emailType, link, templateId } = values
          const cover = '/static/default/phishEmail.png'
          const content = JSON.parse(localStorage.getItem('aiEmailText'))?.content || ''
          createAiEmailTemplate({
            name,
            subject,
            sender,
            content,
            cover,
            emailType,
            link,
            templateId,
          })
            .then(res => {
              setAiVisible(false)
              localStorage.removeItem('aiEmailText')
              setGetEmailParams(origin => ({ ...origin, page: 1 }))
              handleSuccess()
            })
            .catch(_ => {})
        }}
        inputSearch={value => {
          getAiEmailTemplate({ subject: value.subject, emailType: value.emailType })
            .then(res => {
              console.log('res111', res)
              setEmailTemplateList(
                res.data.list.map((item, index) => ({ ...item, id: index })) || [],
              )
            })
            .catch(_ => {})
        }}
        submitLoading={submitLoading}
        getPhishing={getPhishing}
        getAttachmentsList={getAttachmentsList}
        templateList={emailTemplateList || []}
        searchLoading={searchLoading}
        onCancel={() => {
          setAiVisible(false)
        }}
      />

      <Particulars visible={particulars} close={closeParticulars} />
      <EditTemplate isModalVisible={visible} handleCancel={close} />
      <GetPhishingParamsCreateTemplate
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        cont={'1'}
      />

      <Main>
        {emailList?.items?.map(item => (
          <div className="list-main" key={item?.id}>
            {item?.origin_type === 1 && <div className="hint">{t('系统内置')}</div>}
            {item?.origin_type === 2 && <div className="custom">{t('自定义')}</div>}
            {item?.origin_type === 3 && <div className="ai">{t('AI生成')}</div>}
            <div className="list" key={item?.id}>
              <div className="img-main">
                {item?.origin_type === 1 && (
                  <div className="img-container">
                    <Image
                      fallback={`${
                        process.env.NODE_ENV === 'dev' ? '/api' : ''
                      }/static/default/phishEmail_100x100.png`}
                      src={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${item?.cover.replace(
                        /\./g,
                        '_100x100.',
                      )}`}
                      preview={false}
                      onClick={() => {
                        setVisibles({ visible: true, cover: item?.cover })
                      }}
                    />
                  </div>
                )}
                {(item?.origin_type === 2 || item?.origin_type === 3) && item?.email_type === 1 && (
                  <SvgIcon name={'phishing-link'} width={64} height={64} />
                )}
                {(item?.origin_type === 2 || item?.origin_type === 3) && item?.email_type === 2 && (
                  <SvgIcon name={'phishing-task-accessory'} width={64} height={64} />
                )}
              </div>
              <div className="headline">
                <div className="title">{item?.name}</div>
                <div className="text" style={{ display: 'flex' }}>
                  {t('邮件主题：')}
                  <Typography.Text
                    ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
                    style={{ width: 200 }}
                  >
                    {item?.subject}
                  </Typography.Text>
                </div>
                <div className="text" style={{ display: 'flex' }}>
                  <span>{t('发件昵称：')}</span>
                  <Typography.Text
                    ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
                    style={{ width: 200 }}
                  >
                    {item?.sender || '-'}
                  </Typography.Text>
                </div>
                <div className="text">
                  {t('邮件类型：')}
                  {item?.email_type === 2 && <span className="accessory">{t('恶意附件')}</span>}
                  {item?.email_type === 1 && <span className="link">{t('钓鱼链接')}</span>}
                </div>
              </div>
            </div>

            <div className="examine">
              {/*{item?.origin_type === 1 && (*/}
              {/*  <div*/}
              {/*    className="operation"*/}
              {/*    onClick={() => {*/}
              {/*      setVisibles({ visible: true, cover: item?.cover })*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    <IconFont type={'icon-chakan'} style={{ marginRight: 6 }} /> 预览*/}
              {/*  </div>*/}
              {/*)}*/}
              <div
                className="operation"
                onClick={() => setParticulars({ visible: true, id: item.id })}
              >
                <IconFont type={'icon-chakanxiangqing2'} />
                <span style={{ marginLeft: 6 }}>{t('查看详情')}</span>
              </div>
              {(item?.origin_type === 2 || item?.origin_type === 3) && (
                <>
                  <div
                    className="operation"
                    onClick={() =>
                      setVisible({
                        visible: true,
                        id: item.id,
                        type: 1,
                        origin_type: item.origin_type,
                      })
                    }
                  >
                    <IconFont type={'icon-bianji'} style={{ marginRight: 6 }} />
                    <span> {t('编辑')}</span>
                  </div>
                  <div
                    className="operation"
                    onClick={() => setDeleteModal({ visible: true, id: item?.id })}
                  >
                    <IconFont type={'icon-shanchu-m'} style={{ marginRight: 6 }} />
                    <span>{t('删除')}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </Main>
      {!emailList?.items && <Empty image={EmptyImg} />}
      <Image
        key={visibles?.cover}
        style={{ display: 'none' }}
        preview={{
          visible: visibles.visible,
          src: `${process.env.NODE_ENV === 'dev' ? '/api' : ''}${visibles?.cover}`,
          onVisibleChange: value => {
            setVisibles({ visible: value, cover: '' })
          },
        }}
      />

      <DeleteModal
        onOk={deleteEmailHandler}
        onCancel={() => {
          setDeleteModal({ visible: false, id: null })
        }}
        visible={deleteModal.visible}
        text={'此操作将永久删除,是否继续?'}
      />

      {emailList?.items && (
        <div className="pageination">
          <Pagination
            onChange={(page, limit) => {
              setGetEmailParams(origin => ({ ...origin, page, limit }))
            }}
            defaultCurrent={1}
            total={emailList?.total}
            showSizeChanger
            showQuickJumper
            current={getEmailParams.page}
            pageSize={getEmailParams.limit}
            defaultPageSize={20}
            pageSizeOptions={['20', '40', '60', '80', '100']}
            showTotal={totals => (
              <div>
                {t('共')}
                <a>{totals}</a>
                {t('条')}
              </div>
            )}
          />
        </div>
      )}
    </Template>
  )
}
const Template = styled.div`
  .title-btn {
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 10px;
    padding: 0 20px;
    .ant-btn.ai-btn:hover {
      width: 124px;
      height: 100%;
      background: linear-gradient(45deg, #2090a8 0%, #4f4fae 100%) !important;
    }
  }
  .pageination {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
    margin-right: 20px;
  }
  .ant-popover-title {
    height: 50px;
    display: flex;
    align-items: center;
  }
  .search-button {
    background: #f1f3f8;
    border-radius: 6px;
    padding: 9px 18px;
    margin-left: 10px;
    cursor: pointer;
    &:hover {
      color: #0b0a27;
      background: #e2e4f6;
    }
  }
`
const Main = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, minmax(327px, 1fr));
  grid-gap: 20px;
  padding: 0 20px;
  .list-main {
    width: 100%;
    height: 150px;
    background: #ffffff;
    border-radius: 8px;
    padding: 16px 17px;
    border: 1px solid #d9d9d9;
    position: relative;
    .img-main {
      width: 70px;
      height: 94px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      overflow: hidden;
    }
    .img-container {
      width: 64px;
      height: 85px;
      border-radius: 6px;
      overflow: hidden;
      display: flex;
      align-items: center;
      //background: #eeedeb;
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        width: 70px;
        height: 94px;
      }
    }
    .ant-image {
      width: 100%;
    }
    .list {
      display: flex;
    }
    .hint {
      width: 60px;
      height: 20px;
      background: #558492;
      border-radius: 0px 8px 0px 8px;
      color: #ffffff;
      padding: 4px 6px;
      font-size: 12px;
      position: absolute;
      right: -1px;
      top: -1px;
    }
    .custom {
      background: #ed787e;
      border-radius: 0px 8px 0px 8px;
      color: #ffffff;
      padding: 4px 6px;
      font-size: 12px;
      position: absolute;
      right: -1px;
      top: -1px;
    }
    .ai {
      background: linear-gradient(174deg, #2090a8 0%, #4f4fae 100%);
      border-radius: 0px 8px 0px 8px;
      color: #ffffff;
      padding: 4px 6px;
      font-size: 14px;
      position: absolute;
      right: -1px;
      top: -1px;
    }
    .title {
      font-weight: bold;
      margin-bottom: 8px;
    }
    .text {
      margin-bottom: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 13px;
      color: #666666;
    }
    .headline {
      width: calc(100% - 84px);
      margin-left: 17px;
    }
    .examine {
      width: 100%;
      height: 30px;
      background: #f1f1f1;
      border-radius: 0px 0px 8px 8px;
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .operation {
        width: 50%;
        height: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        cursor: pointer;
        border-right: 1px solid #d9d9d9;
        &:last-child {
          border: 0;
        }
      }
    }
    .link {
      padding: 4px 8px;
      background: #ebe9ff;
      font-size: 12px;
      display: inline-block;
      text-align: center;
      color: #645aff;
      border-radius: 4px;
    }
    .accessory {
      padding: 4px 8px;
      background: #f5d9da;
      font-size: 12px;
      display: inline-block;
      text-align: center;
      color: #d0011c;
      border-radius: 4px;
    }
  }
`
